import './Vimeo.svelte.css.proxy.js';
/* src/components/Vimeo.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_element,
	claim_space,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal,
	set_style,
	space
} from "../_snowpack/pkg/svelte/internal.js";

function create_fragment(ctx) {
	let div1;
	let br0;
	let t0;
	let div0;
	let iframe;
	let iframe_src_value;
	let t1;
	let br1;

	return {
		c() {
			div1 = element("div");
			br0 = element("br");
			t0 = space();
			div0 = element("div");
			iframe = element("iframe");
			t1 = space();
			br1 = element("br");
			this.h();
		},
		l(nodes) {
			div1 = claim_element(nodes, "DIV", { style: true });
			var div1_nodes = children(div1);
			br0 = claim_element(div1_nodes, "BR", {});
			t0 = claim_space(div1_nodes);
			div0 = claim_element(div1_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);

			iframe = claim_element(div0_nodes, "IFRAME", {
				src: true,
				frameborder: true,
				allowfullscreen: true,
				title: true,
				class: true
			});

			children(iframe).forEach(detach);
			div0_nodes.forEach(detach);
			t1 = claim_space(div1_nodes);
			br1 = claim_element(div1_nodes, "BR", {});
			div1_nodes.forEach(detach);
			this.h();
		},
		h() {
			if (iframe.src !== (iframe_src_value = "//player.vimeo.com/video/" + /*id*/ ctx[0])) attr(iframe, "src", iframe_src_value);
			attr(iframe, "frameborder", "0");
			iframe.allowFullscreen = "";
			attr(iframe, "title", /*title*/ ctx[1]);
			attr(iframe, "class", "svelte-pz511c");
			attr(div0, "class", "video-container svelte-pz511c");
			set_style(div1, "max-width", "700px");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			append(div1, br0);
			append(div1, t0);
			append(div1, div0);
			append(div0, iframe);
			append(div1, t1);
			append(div1, br1);
		},
		p(ctx, [dirty]) {
			if (dirty & /*id*/ 1 && iframe.src !== (iframe_src_value = "//player.vimeo.com/video/" + /*id*/ ctx[0])) {
				attr(iframe, "src", iframe_src_value);
			}

			if (dirty & /*title*/ 2) {
				attr(iframe, "title", /*title*/ ctx[1]);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div1);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { id } = $$props;
	let { title } = $$props;

	$$self.$$set = $$props => {
		if ("id" in $$props) $$invalidate(0, id = $$props.id);
		if ("title" in $$props) $$invalidate(1, title = $$props.title);
	};

	return [id, title];
}

class Vimeo extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { id: 0, title: 1 });
	}
}

export default Vimeo;
//# sourceMappingURL=Vimeo.svelte.js.map
